import React from 'react';
import { useParams } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import DetalleAlta from './DetalleAlta';
import PantallaProceso from './PantallaProceso';
import { RUTA_EMBUDO } from './rutasProceso';

/**
 * AltaPage — el alta con su propia ruta (FASE_PANTALLA_DE_ALTA_Y_BAJA.md, §6, pieza 1).
 *
 * El `:id` se valida AQUÍ, antes de pedir nada: `/…/altas/abc` no es «no existe», es una URL que
 * no es de un alta, y mandarla al servidor sólo la convertiría en un error menos claro.
 *
 * `key` fuerza a montar de nuevo al pasar de un alta a otra: el componente guarda en su estado el
 * detalle y lo que se está editando, y nada de eso debe sobrevivir al cambio de id.
 */
export default function AltaPage() {
  const { id } = useParams();
  if (!/^[1-9][0-9]*$/.test(String(id || ''))) {
    return (
      <PantallaProceso rutaListado={RUTA_EMBUDO}>
        <div className="px-5 py-12 text-center text-sm text-v25-ink-700">
          <AlertCircle className="mx-auto mb-2 h-6 w-6 text-v25-ink-400" />
          «{id}» no es el número de un alta.
        </div>
      </PantallaProceso>
    );
  }
  return <DetalleAlta key={id} altaId={Number(id)} />;
}
